import Icon from 'veui/components/Icon'
import { IconRedo } from 'dls-icons-vue'

Icon.register('redo', IconRedo)
